import React, { useState } from 'react';
import { 
  Box, 
  Card, 
  TextField, 
  Button, 
  Typography, 
  Container,
  Alert
} from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function ActivateAccount() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();
  const token = searchParams.get('token');
  
  const [password, setPassword] = useState('');
  const [confirmPassword, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      return setError('Les mots de passe ne correspondent pas.');
    }

    if (password.length < 8) {
      return setError('Le mot de passe doit contenir au moins 8 caractères.');
    }

    setLoading(true);
    try {
      const response = await fetch('/api/auth/activate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(true);
        // Connexion automatique avec le token reçu
        if (data.token && data.user) {
          authLogin(data.user, data.token);
          // Redirection selon le rôle
          const isAdmin = ['ADMIN', 'SUPERADMIN'].includes(data.user.role);
          setTimeout(() => navigate(isAdmin ? '/admin' : '/portal'), 1500);
        } else {
          setTimeout(() => navigate('/login'), 3000);
        }
      } else {
        setError(data.error || "Erreur lors de l'activation");
      }
    } catch (err) {
      setError('Impossible de contacter le serveur');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <Container maxWidth="xs">
        <Box sx={{ mt: 10 }}>
          <Alert severity="error">Lien d'activation invalide ou manquant.</Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Card sx={{ p: 4, width: '100%', backgroundColor: 'background.paper', backgroundImage: 'none', border: '1px solid rgba(255, 255, 255, 0.06)' }}>
          <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            Activer votre compte
          </Typography>
          <Typography variant="body2" align="center" sx={{ mb: 4, color: 'text.secondary' }}>
            Définissez votre mot de passe pour accéder à votre espace.
          </Typography>
          
          {success ? (
            <Alert severity="success">
              Compte activé avec succès ! Connexion en cours...
            </Alert>
          ) : (
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Nouveau mot de passe"
                type="password"
                variant="outlined"
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <TextField
                fullWidth
                label="Confirmer le mot de passe"
                type="password"
                variant="outlined"
                margin="normal"
                value={confirmPassword}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                sx={{ mb: 3 }}
              />
              
              {error && (
                <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                  {error}
                </Typography>
              )}
              
              <Button
                fullWidth
                variant="contained"
                type="submit"
                size="large"
                disabled={loading}
              >
                {loading ? 'Activation...' : 'Activer mon compte'}
              </Button>
            </form>
          )}
        </Card>
      </Box>
    </Container>
  );
}

export default ActivateAccount;